import { motion } from "framer-motion";
import { Percent, Zap, CreditCard } from "lucide-react";
import { useTranslation } from "react-i18next";

export default function Payouts() {
  const { t } = useTranslation();
  const ITEMS = [
    { icon: Percent, title: t("payouts.card1Title"), desc: t("payouts.card1Body") },
    { icon: Zap, title: t("payouts.card2Title"), desc: t("payouts.card2Body") },
    { icon: CreditCard, title: t("payouts.card3Title"), desc: t("payouts.card3Body") },
  ];
  return (
    <section id="payouts" data-testid="payouts-section" className="relative py-14 lg:py-28 overflow-hidden">
      <div className="relative max-w-7xl mx-auto px-5 lg:px-8">
        <div className="text-center mb-14">
          <div className="pill-mono inline-flex mb-5">{t("payouts.pill")}</div>
          <h2 className="font-display text-4xl lg:text-5xl font-medium tracking-tight mb-4">
            {t("payouts.title")} <span className="text-gradient-brand">{t("payouts.titleAccent")}</span>
          </h2>
          <p className="text-zinc-400 max-w-2xl mx-auto">
            {t("payouts.subtitle")}
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-5">
          {ITEMS.map((it, i) => (
            <motion.div
              key={it.title}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.1, duration: 0.5 }}
              className="card-beam p-6 flex gap-4"
              data-testid={`payout-card-${i}`}
            >
              <div className="w-12 h-12 rounded-lg bg-brand/10 border border-brand/30 grid place-items-center shrink-0">
                <it.icon className="text-brand" size={22} />
              </div>
              <div className="min-w-0">
                <h3 className="font-display text-lg font-medium text-white mb-2 leading-tight">{it.title}</h3>
                <p className="text-zinc-400 text-sm leading-relaxed font-light">{it.desc}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
